export const qualificationOptions = [
  { value: '', label: '—' },
  { value: '1SK', label: '1-я судейская категория' },
  { value: '2SK', label: '2-я судейская категория' },
  { value: '3SK', label: '3-я судейская категория' },
  { value: 'VK', label: 'Всероссийская категория' },
];

export const rateOptions = [
  { value: '', label: '—' },
  { value: '1UR', label: '1-й юношеский разряд' },
  { value: '2UR', label: '2-й юношеский разряд' },
  { value: '3UR', label: '3-й юношеский разряд' },
  { value: '1R', label: '1-й разряд' },
  { value: '2R', label: '2-й разряд' },
  { value: '3R', label: '3-й разряд' },
  { value: 'KMS', label: 'Кандидат в мастера спорта (КМС)' },
  { value: 'MS', label: 'Мастер спорта (МС)' },
];

export const statusOptions = [
  { value: '', label: '—' },
  { value: 'sportsman', label: 'Спортсмен' },
  { value: 'referee', label: 'Судья' },
  { value: 'manager', label: 'Организатор' },
  { value: 'federation_representative', label: 'Представитель федерации' },
];

export const clubActiveOptions = [
  { value: 'true', label: 'Активен' },
  { value: 'false', label: 'Неактивен' },
];
